var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CreationWizardStepHeaderWrapper',_vm._g(_vm._b({},'CreationWizardStepHeaderWrapper',_vm.headerWrapperProps,false),_vm.headerWrapperListeners),[_c('ToolHeader',{attrs:{"toolPlacementId":_vm.selectedToolPlacementId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }